import { useCallback, useState } from 'react'

import { F0Button } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { Modals } from 'modules/integrations/components/SyncButton/Modals'
import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import type { SyncBarStatus } from 'modules/integrations/hooks/useSyncBarData'

const getSyncActionLabel = (status: SyncBarStatus, integrationName: string): string => {
  switch (status) {
    case 'pending':
      return i18n.t('integrations.sync_bar.action.sync_to', { integration: integrationName })
    case 'syncing':
      return i18n.t('integrations.sync_bar.action.syncing')
    case 'failed':
      return i18n.t('integrations.sync_bar.action.review_and_sync')
    case 'synced':
      return i18n.t('integrations.sync_bar.action.sync_to', { integration: integrationName })
  }
}

interface SyncBarActionProps {
  syncStatus: SyncBarStatus
  integrationName: string
}

export const SyncBarAction = ({ syncStatus, integrationName }: SyncBarActionProps) => {
  const { isSyncing } = usePrivateIntegrationsSyncContext()
  const [showModal, setShowModal] = useState(false)

  const handleSyncClick = useCallback(() => {
    setShowModal(true)
  }, [])

  const actionLabel = getSyncActionLabel(syncStatus, integrationName)
  const isSyncDisabled = syncStatus === 'syncing' || isSyncing

  return (
    <>
      <F0Button
        variant="outline"
        label={actionLabel}
        onClick={handleSyncClick}
        disabled={isSyncDisabled}
      />
      {showModal && <Modals setShowModal={setShowModal} />}
    </>
  )
}
